import type { EnumUnion } from "@dresscode-frontend/utility-types";
import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";
import { ConfidentialityLevel, ProviderType } from "@/features/storage-files";

export const Columns = {
  FILE_NAME: "FILE_NAME",
  CONFIDENTIALITY_LEVEL: "CONFIDENTIALITY_LEVEL",
  PERMISSION_HOLDERS: "PERMISSION_HOLDERS",
  PARENT_FOLDER: "PARENT_FOLDER",
  OWNER: "OWNER",
  LAST_UPDATE_TIME: "LAST_UPDATE_TIME",
} as const;
export type Columns = EnumUnion<typeof Columns>;

export const SearchSchema = z.object({
  provider: z.nativeEnum(ProviderType).default(ProviderType.BOX),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  parentFolderIdIn: z.array(z.string()).optional(),
  confidentialityLevelIn: z
    .array(z.nativeEnum(ConfidentialityLevel))
    .optional(),
  sortColumn: z.nativeEnum(Columns).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});
export type SearchSchema = z.infer<typeof SearchSchema>;
